module.exports = __webpack_public_path__ + "img/Weapon_75.bd89b0a2.png";